import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { CdkTableModule } from '@angular/cdk/table'

import {
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatMenuModule,
    MatIconModule,
    MatDialogModule,
    MatToolbarModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatGridListModule,
    MatButtonToggleModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatCardModule,
    MatRadioModule,
    MatTableModule,
    MatTooltipModule,
    MatSidenavModule,
    MatPaginatorModule,
    MatSortModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatListModule,
    MatTabsModule
    
} from '@angular/material'

const materialModules: any[] = [
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatMenuModule,
    MatIconModule,
    MatDialogModule,
    MatToolbarModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatGridListModule,
    MatButtonToggleModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatGridListModule,
    MatNativeDateModule,
    FlexLayoutModule,
    MatCardModule,
    MatRadioModule,
    MatTableModule,
    CdkTableModule,
    MatTooltipModule,
    MatSidenavModule,
    MatPaginatorModule,
    MatSortModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatListModule,
    MatTabsModule
];

@NgModule({
    imports: materialModules,
    exports: materialModules
})

export class MaterialModule { }